<template>
  <exec-report-panel report-name="loyalty" title="Lealtad, cashback y puntos" :filters="filters" @error="$emit('error', $event)" />
</template>

<script>
import ExecReportPanel from './ExecReportPanel.vue';
// Pestaña 4 · Lealtad y puntos (doc 04 §3, reporte 5).
export default { name: 'ExecLoyalty', components: { ExecReportPanel }, props: { filters: { type: Object, default: () => ({}) } } };
</script>
